/** @module csi/toolbar/MultiFilterCondition */
define([
	"dojo/_base/declare",
	"dijit/_TemplatedMixin",
	"dijit/_WidgetBase",
	"csi/_base/underscore",
	"csi/html",
	"csi/locale",
	"csi/xml",
	"dojo/text!./MultiFilterCondition.html",
], function(declare,_TemplatedMixin,_WidgetBase,_,html,locale,xml,template) {

	return declare([_WidgetBase, _TemplatedMixin], {
		baseClass: "csi-filter-condition",
		templateString: template,

		/** @property {string} label */
		label: "",

		/** @property {Any} value */
		value: null,

		/**
		 * Map label to labelNode
		 */
		_setLabelAttr: {node: "labelNode", type: "innerText"},

		/**
		 * Get display names of values
 		 * @param {String} value
		 */
		_getDisplayValue: function(value) {
			if(value == xml.VALUE_BLANK || value == xml.VALUE_NONBLANK) {
				return locale.resource(value);
			}
			return value;
		},

		/**
		 * Populate widget with individual lines for each value
 		 * @param {Object[]} value
		 */
		_setValueAttr: function(value) {
			if (value.length == 1) {
				html.text(this.opNode, " " + locale.resource("OP_EQ").toLowerCase() + " ");
				html.text(this.valueNode, this._getDisplayValue(value[0]));
			} else {
				html.text(this.opNode, " " + locale.resource("MultiFilterOneOrMoreOf") + ":");
				_.each(value, function(v) {
					html.create("div", {innerText: this._getDisplayValue(v)}, this.valueNode);
				}, this);
			}
		}
	});
});